import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updatePartnerStaff } from '../../api/partner-staff.ts';
import type { UpdatePartnerStaffRequest } from '../../api/requests/partner-staff-request.ts';

export default function useUpdatePartnerStaff(): UseMutationResult<
  string,
  Error,
  UpdatePartnerStaffRequest
> {
  return useMutation({ mutationFn: updatePartnerStaff });
}
